import admin from './admin';
import sidebar from './sidebar';
import schools from './schools';
import candidate from './candidate';
import userAccount from './user-account';

export default {
  sidebar,
  schools,
  candidate,
  userAccount,
  admin
};



// WEBPACK FOOTER //
// ./src/services/access-control/permissions/index.js